import React, { useEffect, useState } from "react";

const Splash = ({ visible = true }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsMounted(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 z-[9999] flex h-full w-full items-center justify-center bg-white transition-opacity duration-500 ease-out ${
        visible && isMounted ? "opacity-100" : "opacity-0"
      }`}
    >
      <img
        src="/sites/borgono/splashlogo.png"
        alt="Carnaval Club"
        className={`h-auto w-full max-w-[200px] object-contain transition-all duration-500 ease-out ${
          visible && isMounted
            ? "translate-y-0 scale-100 opacity-100"
            : "-translate-y-1 scale-[0.985] opacity-0"
        }`}
      />
    </div>
  );
};

export default Splash;
